import React, { useEffect } from "react";
import SingleCardSchedule from "../Reuse/SingleCardSchedule";
import EventImg from "../../../../assets/images/SakibBanner2.png";
import { useLocation, useParams } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import moment from "moment";
import { serverInfo } from "../../../../App";
import { useContext } from "react";

const SingleSchedule = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  const location = useLocation();
  const eventType = location.state;
  const [postData, setPostData] = useState([]);

  useEffect(() => {
    axios.get(`/api/admin/dashboard/posts/${eventType?.title}`).then((res) => {
      if (res.data.status === 200) {
        setPostData(res.data.post);
      }
    });
  }, []);
  return (
    <>
      <div className="col-md-12 ">
        <div className="row">
          {postData?.map((post) => (
            <SingleCardSchedule
              post={post}
              eventType={eventType}
              key={post.id}
              link={`/superstar-admin/schedule/date/${post.id}/${eventType?.title}`}
              image={
                post.banner
                  ? post.banner == null
                    ? EventImg
                    : imageCdnUrl+post.banner
                  : post.image == null
                  ? EventImg
                  : imageCdnUrl+post.image
              }
              time={moment(post.created_at).format("HH:mm a")}
              date={moment(post.created_at).format("LL")}
              title={post.title}
              description={post?.description}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default SingleSchedule;
